module.exports = __webpack_public_path__ + "img/check2.150d074e.svg";